export default "__VITE_ASSET__Cw74c10M__"